import React from 'react';
import './ScanProcessing.css';

const ScanProcessing = () => {
  return (
    <div className="bts-scan-processing">
      <div className="bts-scan-processing__spinner" />
      <p className="bts-scan-processing__title">กำลังตรวจสอบ...</p>
      <p className="bts-scan-processing__subtitle">โปรดรอสักครู่</p>
    </div>
  );
};

export default ScanProcessing;
